import React from "react";

import { formatNumber, getVariance } from "utils";

import { Card, Col, MapInteractive } from "components";

export const DrawPolygonMap = ({ drawnArea, field, location, markers, setupDrawingAPI }) => (
  <>
    <Col sm={24} md={12}>
      <h4>Drawn polygon size</h4>
      <p>
        {drawnArea ? formatNumber({ number: drawnArea, decimalPlaces: 4 }) : 0}
        ha ({drawnArea ? getVariance(field.size, drawnArea, 2) : 0}% variance)
      </p>
      <Card className="map-card">
        <MapInteractive
          markers={markers.map((marker) => ({
            ...marker,
            size: "l",
          }))}
          location={location}
          scaleControl={true}
          setupDrawingAPI={setupDrawingAPI}
          zoomControl={true}
        />
      </Card>
    </Col>
  </>
);
